import { toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "input__label" }
const _hoisted_2 = { class: "input__content" }
const _hoisted_3 = { class: "input__main-content" }
const _hoisted_4 = ["type", "placeholder", "required"]
const _hoisted_5 = { class: "input__sub-text" }
const _hoisted_6 = { class: "input__error" }
const _hoisted_7 = {
  key: 0,
  class: "input__desc"
}
const _hoisted_8 = {
  key: 1,
  class: "input__desc"
}
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCheck = _resolveComponent("IconCheck")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["input__input", { error: _ctx.errorMsg }]),
          type: _ctx.type,
          placeholder: String(_ctx.placeholder),
          required: _ctx.required,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
        }, null, 10, _hoisted_4), [
          [_vModelDynamic, _ctx.inputValue]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.errorMsg), 1),
          (_ctx.desc)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.desc), 1))
            : _createCommentVNode("", true),
          (_ctx.counter)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.currentCounter) + " / " + _toDisplayString(_ctx.counter), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.inlineButton)
        ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-secondary btn-m input__btn",
            disabled: !!_ctx.errorMsg || !!_ctx.isEmpty || !!_ctx.outOfCharacters,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
          }, [
            _createVNode(_component_IconBase, null, {
              default: _withCtx(() => [
                _createVNode(_component_IconCheck)
              ]),
              _: 1
            })
          ], 8, _hoisted_9)), [
            [_directive_ripple]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}